$(function() {
    $('.js-form-contact').validate({
        rules: {
            'name': {
                minlength: 3
            },
            'message': {
                minlength: 5
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            $(form).find('button[type="submit"]').addClass('is-loading').prop('disabled', true);

            $('.js-contact-error').slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(() => {
                Form.ajaxPost(form, function(data) {
                    var msg = data.msg.format;

                    if (!msg) {
                        msg = data.msg;
                    }

                    if (!data.status) {
                        $('.js-contact-error')
                            .text(msg)
                            .slideDown();
                    } else {
                        $(form).slideUp(250, function(){
                            $('.js-contact-success')
                                .text(msg)
                                .slideDown(250);
                        });
                    }
                }, "json").fail(function() {
                    $('.js-contact-error')
                        .text($('.js-contact-error').data('general-error'))
                        .slideDown();
                }).always(function() {
                    $(form).find('button[type="submit"]').removeClass('is-loading').prop('disabled', false);
                });
            });
        }
    });
});
